import { createContext } from "react";

/**
 * O "Run all" andando, visto pelo terminal da conversa: com a fila ativa, encerrar a unidade
 * em voo pede a escolha entre só ela (e seguir para a próxima) ou a fila toda.
 */
export interface QueueControl {
  active: boolean;
  /** Encerra a unidade em voo e limpa o que falta na fila. */
  stopAll: () => void;
}

export const QueueControlContext = createContext<QueueControl | null>(null);
